import Store from "App/Store.js";

export default checkoutBasket => Store.dispatch({type: "checkoutBasket", checkoutBasket});
